export enum Choice {
  purchase = 'purchase',
  service = 'service',
  none = 'none'
}
